var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataLeakLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4973 1.66797L17.5 6.66797L17.501 10.2185C17.0184 9.81847 16.4528 9.51614 15.834 9.3408L15.8333 7.5013H11.6667V3.33464H4.16667V16.668L8.38258 16.6687C8.48008 17.2817 8.7185 17.849 9.06425 18.3351L3.32783 18.3346C2.90343 18.3346 2.55341 18.0156 2.50558 17.6046L2.5 17.5081V2.49447C2.5 2.07933 2.82241 1.72252 3.23777 1.67366L3.33518 1.66797H12.4973Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3137 11.0414L11.4913 12.8638C10.4848 13.8704 10.4848 15.5022 11.4913 16.5087C12.4978 17.5152 14.1296 17.5152 15.1361 16.5087C16.1427 15.5022 16.1427 13.8704 15.1361 12.8638L13.3137 11.0414ZM13.3137 10L15.6569 12.3431C16.9509 13.6372 16.9509 15.7353 15.6569 17.0294C14.3628 18.3235 12.2646 18.3235 10.9706 17.0294C9.67648 15.7353 9.67648 13.6372 10.9706 12.3431L13.3137 10Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataLeakLine);
export default __webpack_public_path__ + "static/media/data-leak-line.72f4fb330510ac5c5cd541639341b4d9.svg";
export { ForwardRef as ReactComponent };